import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import theme from "shared/theme";
import { COLOR_GREY_7, COLOR_WHITE } from "shared/theme/colors";
import { text } from "shared/theme/mixins";

export const StyledNavItemIconContainer = styled(Box, {
  shouldForwardProp: (propName) =>
    !["isActive", "iconColor"].includes(propName),
})<{
  active: boolean;
  iconColor?: string;
  expanded?: boolean;
}>`
  margin-right: ${({ expanded }) => (expanded ? "1rem" : "0")};
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
    path {
      fill: ${({ active, iconColor }) =>
        active ? iconColor || COLOR_WHITE : iconColor || COLOR_GREY_7};
    }
  }
`;

export const StyledNavItemTypography = styled(Typography, {
  shouldForwardProp: (props) => props !== "active",
})<{ active: boolean }>`
  ${({ active }) => active && text(theme.typography.bodyLSemiBold)};
  color: ${({ active }) => (active ? COLOR_WHITE : COLOR_GREY_7)};
  white-space: nowrap;
`;
